export default __webpack_public_path__ + "static/media/chatgpt_history_fr.dae341ff.png";